// extracted by mini-css-extract-plugin
export default {"bottomLink":"Protection_bottomLink__ZngZK","protectionContent":"Protection_protectionContent__YkIGs"};